// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__efnGu","info":"UpdateTermsInfo_info__1fsCO"};